import { uiConfig } from '../../ui/app-ui-config';

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) return parts.pop().split(';').shift(); /* eslint-disable-line */
}

function setCookie(name, value, days, domain = `.${uiConfig.domain}`) {
    let expires = '';

    if (days) {
        const date = new Date();

        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); /* eslint-disable-line */

        expires = `; expires=${date.toUTCString()}`;
    }

    document.cookie = `${name}=${value}${expires}; path=/; domain=${domain}; Secure; SameSite=None`;
}

export {
    getCookie,
    setCookie
};
